// Shared @react-google-maps/api loader id. Every component that calls
// useJsApiLoader/useLoadScript must pass the same `id`, or the library logs
// an "already loaded with different options" warning — import this instead
// of redeclaring the id inline.
export const GOOGLE_MAPS_LOADER_ID = "identity-portal-google-maps";
